import { AppRouter } from './router/AppRouter';
import { EnvBanner } from './components/common/EnvBanner';

function App() {
  return (
    // The banner and the app share the height of the screen: outside production, the app's own
    // scrolling area would otherwise end below the screen by the banner's height.
    <div className="flex h-screen flex-col">
      <EnvBanner />
      <div className="min-h-0 flex-1 overflow-y-auto">
        <AppRouter />
      </div>
    </div>
  );
}

export default App;
